import { Option } from "api/types/_public";
import imgEmail from "../assets/images/platform/mail.webp";
import imgGoogle from "../assets/images/platform/google.svg";
import imgKakao from "../assets/images/platform/kakao.svg";
import imgNaver from "../assets/images/platform/naver.svg";
import imgApple from "../assets/images/platform/apple.svg";
import imgAmazon from "../assets/images/platform/amazon.svg";
import imgFirebase from "../assets/images/platform/firebase.svg";
import imgFacebook from "../assets/images/platform/facebook.svg";
import imgTiktok from "../assets/images/platform/tiktok.svg";
import imgOffline from "../assets/images/platform/offline.png";
import imgMeta from "../assets/images/platform/meta.png";
import imgInstall from "../assets/images/platform/install.png";
import imgAgency from "../assets/images/platform/agency.png";
import imgGooglePlay from "../assets/images/platform/google-play.png";
import imgAppStore from "../assets/images/platform/app-store.png";
import imgAndroid from "../assets/images/platform/android.png";
import imgIOS from "../assets/images/platform/ios.png";
import imgBaive from "../assets/images/appname/baive.png";
import imgBaiveManager from "../assets/images/appname/baive-manager.png";
import noImage from "../assets/images/no-image.jpg";
import imgUSD from "../assets/images/currency/usd.png";
import imgKRW from "../assets/images/currency/won.png";

export const SCHEDULE_OPTIONS: Option[] = [
  {
    label: "Now",
    value: "now",
  },
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  // {
  //   label: 'Except Holiday In Korea',
  //   value: 'except_holiday_in_Korea',
  // }
];

export const SCHEDULE_MONTHLY_OPTIONS: Option[] = Array.from(
  { length: 31 },
  (_, index) => {
    const day = (index + 1).toString().padStart(2, "0");
    return { label: `${day}th`, value: day };
  }
);

export const SCHEDULE_WEEKLY_OPTIONS: Option[] = [
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "7",
  },
];

export const SCHEDULE_CAMPAIGN_STATISTIC_OPTIONS: Option[] = [
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
];

export const ACTION_TYPE_CAMPAIGN = {
  SAVE: "save",
  POST: "post",
};

export const METHOD_OPTIONS: Option[] = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const IS_OPTIONS: Option[] = [
  {
    label: "YES",
    value: "1",
  },
  {
    label: "NO",
    value: "0",
  },
];

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: "scroll",
  MODAL: "modal",
};

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

//dispatch

export const TYPE_POST: Option[] = [
  {
    label: "Feed",
    value: "feed",
  },
  {
    label: "Card",
    value: "card",
  },
];

// Status
export const ENUM_STATUS_ACTIVE_DISABLE = {
  ACTIVATE: 1,
  DISABLED: 2,
};

export const COLOR_STATUS_ACTIVE_DISABLE: any = {
  [ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE]: "success",
  [ENUM_STATUS_ACTIVE_DISABLE.DISABLED]: "danger",
};

export const STATUS_ACTIVE_DISABLE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Disable",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];

// Artist
export const ENUM_TYPE_ARTIST = {
  DEFAULT: "default",
  IDOL: "idol",
  ACTOR: "actor",
  ENTERTAINMENT: "entertainment",
};

export const COLOR_TYPE_ARTIST: any = {
  [ENUM_TYPE_ARTIST.DEFAULT]: "warning",
  [ENUM_TYPE_ARTIST.IDOL]: "primary",
  [ENUM_TYPE_ARTIST.ACTOR]: "success",
  [ENUM_TYPE_ARTIST.ENTERTAINMENT]: "danger",
};

export const COLOR_TYPE_ARTIST_TDI: any = {
  1: "warning",
  2: "primary",
  3: "success",
  4: "danger",
};

export const ENUM_STATUS_ARTIST = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const COLOR_STATUS_ARTIST: any = {
  [ENUM_STATUS_ARTIST.ACTIVATED]: "success",
  [ENUM_STATUS_ARTIST.DISABLED]: "danger",
};

export const STATUS_ARTIST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_ARTIST.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_ARTIST.DISABLED,
  },
];

// User
export const ENUM_STATUS_USER = {
  PENDING: "pending",
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const COLOR_STATUS_USER: any = {
  [ENUM_STATUS_USER.PENDING]: "primary",
  [ENUM_STATUS_USER.ACTIVATED]: "success",
  [ENUM_STATUS_USER.DISABLED]: "danger",
};

export const STATUS_USER_OPTION = [
  {
    label: "Pending",
    value: ENUM_STATUS_USER.PENDING,
  },
  {
    label: "Activated",
    value: ENUM_STATUS_USER.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_USER.DISABLED,
  },
];

//Advertisement

export const ENUM_STATUS_ADVERTISEMENT = {
  ACTIVATED: "true",
  DISABLED: "false",
};

export const COLOR_STATUS_ADVERTISEMENT: any = {
  [ENUM_STATUS_ADVERTISEMENT.ACTIVATED]: "success",
  [ENUM_STATUS_ADVERTISEMENT.DISABLED]: "danger",
};

export const STATUS_ADVERTISEMENT_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_ADVERTISEMENT.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_ADVERTISEMENT.DISABLED,
  },
];

export const ENUM_POSITION_ADVERTISEMENT = {
  HOT: "hot",
  NEWS: "news",
  WALLPAPER_EDIT: "wallpaper_edit",
  VIDEO: "video",
  FEED: "feed",
};

export const COLOR_POSITION_ADVERTISEMENT: any = {
  [ENUM_POSITION_ADVERTISEMENT.HOT]: "warning",
  [ENUM_POSITION_ADVERTISEMENT.NEWS]: "primary",
  [ENUM_POSITION_ADVERTISEMENT.WALLPAPER_EDIT]: "info",
  [ENUM_POSITION_ADVERTISEMENT.VIDEO]: "danger",
  [ENUM_POSITION_ADVERTISEMENT.FEED]: "success",
};

export const COLOR_STATUS_USED: any = {
  used: "primary",
  unused: "success",
};

export const LIST_OPTION_GENDER = [
  // {
  //   label: "Gender_Unknown",
  //   value: "unknown",
  // },
  {
    label: "Gender_Male",
    value: "male",
  },
  {
    label: "Gender_Female",
    value: "female",
  },
];

export const LIST_OPTION_PLATFORM = [
  {
    label: "Platform_Email",
    value: "default",
  },
  {
    label: "Platform_Kakao",
    value: "kakao",
  },
  {
    label: "Platform_Naver",
    value: "naver",
  },
  {
    label: "Platform_Google",
    value: "google",
  },
  {
    label: "Platform_Apple",
    value: "apple",
  },
  {
    label: "Platform_Apple_Firebase",
    value: "firebase",
  },
];

export const LIST_OPTION_OS = [
  {
    label: "iOS",
    value: "ios",
  },
  {
    label: "Android",
    value: "android",
  },
];

export const getPlatFormImage = (type: string) => {
  switch (type) {
    case "default":
      return imgEmail;
    case "google":
      return imgGoogle;
    case "naver":
      return imgNaver;
    case "kakao":
      return imgKakao;
    case "apple":
      return imgApple;
    case "amazon":
      return imgAmazon;
    case "firebase":
      return imgFirebase;
    case "facebook":
      return imgFacebook;
    case "tiktok":
      return imgTiktok;
    case "offline":
      return imgOffline;
    case "guest":
      return imgEmail;
    case "meta":
      return imgMeta;
    case "store":
      return imgInstall;
    case "agency":
      return imgAgency;
    case "google-play":
      return imgGooglePlay;
    case "app-store":
      return imgAppStore;
    case "android":
      return imgAndroid;
    case "ios":
      return imgIOS;
    case "KRW":
      return imgKRW;
    case "USD":
      return imgUSD;
    default:
      return "";
  }
};

export const getOptionImage = (type: string) => {
  switch (type) {
    case "baive":
      return imgBaive;
    case "baive_manager":
      return imgBaiveManager;
    case "user":
      return imgBaive;
    case "manager":
      return imgBaiveManager;
    case "meta":
      return imgMeta;
    case "google":
      return imgGoogle;
    default:
      return noImage;
  }
};

export const LIST_OPTION_ROLE = [
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "premium",
    label: "Premium",
  },
];

export const ENUM_TYPE_ADVERTISEMENT = {
  NATIVE: "native",
  VIDEO: "video",
};

export const COLOR_TYPE_ADVERTISEMENT: any = {
  [ENUM_TYPE_ADVERTISEMENT.NATIVE]: "primary",
  [ENUM_TYPE_ADVERTISEMENT.VIDEO]: "danger",
};

//notification setting
export const ENUM_NOTI_SETTING_STATUS = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const NOTI_SETTING_STATUS_OPTION = [
  { label: "Activated", value: ENUM_NOTI_SETTING_STATUS.ACTIVATED },
  { label: "Disabled", value: ENUM_NOTI_SETTING_STATUS.DISABLED },
];

export const ENUM_NOTI_SETTING_TYPE = {
  HOT_FEED: "hot_feed",
  WALLPAPER: "wallpaper",
  SNAP: "snap",
  PHOTO_NEWS: "photo_news",
  EVENT_AND_PROMOTION: "event_and_promotion",
};

export const NOTI_SETTING_TYPE_OPTION = [
  { label: "Hot Feed", value: ENUM_NOTI_SETTING_TYPE.HOT_FEED },
  { label: "Wallpaper", value: ENUM_NOTI_SETTING_TYPE.WALLPAPER },
  { label: "Snap", value: ENUM_NOTI_SETTING_TYPE.SNAP },
  { label: "Photo News", value: ENUM_NOTI_SETTING_TYPE.PHOTO_NEWS },
  {
    label: "Event And Promotion",
    value: ENUM_NOTI_SETTING_TYPE.EVENT_AND_PROMOTION,
  },
];

export const NOTI_SETTING_TYPE_COLOR: any = {
  [ENUM_NOTI_SETTING_TYPE.HOT_FEED]: "warning",
  [ENUM_NOTI_SETTING_TYPE.WALLPAPER]: "primary",
  [ENUM_NOTI_SETTING_TYPE.SNAP]: "info",
  [ENUM_NOTI_SETTING_TYPE.PHOTO_NEWS]: "danger",
  [ENUM_NOTI_SETTING_TYPE.EVENT_AND_PROMOTION]: "success",
};

export const ENUM_NOTIFY_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};

export const COLOR_NOTIFY_TYPE: any = {
  [ENUM_NOTIFY_TYPE.AUTO]: "primary",
  [ENUM_NOTIFY_TYPE.MANUAL]: "warning",
};

export const ENUM_PUSH_STATUS = {
  WAITING: "waiting",
  COMPLETED: "completed",
};

export const COLOR_PUSH_STATUS: any = {
  [ENUM_PUSH_STATUS.WAITING]: "primary",
  [ENUM_PUSH_STATUS.COMPLETED]: "success",
};

export const LIST_OPTION_PUSH_STATUS = [
  {
    value: ENUM_PUSH_STATUS.WAITING,
    label: "Waiting",
  },
  {
    value: ENUM_PUSH_STATUS.COMPLETED,
    label: "Completed",
  },
];

export const ENUM_BAR_LIST_PLAN = {
  LIST_PLAN: "List",
  BOOST_PLAN: "Boost",
};

export const COLOR_BAR_LIST_PLAN: any = {
  [ENUM_BAR_LIST_PLAN.LIST_PLAN]: "primary",
  [ENUM_BAR_LIST_PLAN.BOOST_PLAN]: "warning",
};

export const LIST_OPTION_BAR_LIST_PLAN = [
  {
    value: ENUM_BAR_LIST_PLAN.LIST_PLAN,
    label: "Plan_List",
  },
  {
    value: ENUM_BAR_LIST_PLAN.BOOST_PLAN,
    label: "Plan_Boost",
  },
];

export const ENUM_BAR_LIST_OPEN_STATUS = {
  OPEN: 1,
  CLOSED: 0,
};

export const COLOR_BAR_LIST_OPEN_STATUS: any = {
  [ENUM_BAR_LIST_OPEN_STATUS.OPEN]: "success",
  [ENUM_BAR_LIST_OPEN_STATUS.CLOSED]: "danger",
};

export const LIST_OPTION_BAR_LIST_OPEN_STATUS = [
  {
    label: "Open",
    value: ENUM_BAR_LIST_OPEN_STATUS.OPEN,
  },
  {
    label: "Closed",
    value: ENUM_BAR_LIST_OPEN_STATUS.CLOSED,
  },
];

export const COLOR_BAR_LIST_PARTNER_STATUS: any = {
  ["partnered"]: "success",
  ["general"]: "danger",
};

export const LIST_OPTION_BAR_LIST_PARTNER_STATUS = [
  {
    label: "Partner",
    value: "partnered",
  },
  {
    label: "General",
    value: "general",
  },
];

export const LIST_OPTION_BAR_LIST_TYPE = [
  {
    label: "Lounge",
    value: "Lounge",
  },
  {
    label: "Theme Bar",
    value: "Theme Bar",
  },
  {
    label: "Traditional",
    value: "Traditional",
  },
  {
    label: "Skybar",
    value: "Skybar",
  },
];

export const LIST_OPTION_BAR_LIST_RATING = [1, 2, 3, 4, 5]?.map(
  (item: any) => ({
    value: item,
    label: item,
  })
);

export const ENUM_BAR_DETAIL_STAFF_POSITION = {
  NORMAL: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_BAR_DETAIL_STAFF_POSITION: any = {
  [ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL]: "warning",
  [ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER]: "danger",
  [ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER]: "info",
};

export const LIST_OPTION_BAR_DETAIL_STAFF_POSITION = [
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL,
    label: "Normal",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER,
    label: "Bartender",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER,
    label: "Manager",
  },
];

export const LIST_OPTION_BAR_DETAIL_WORKING_TIME_DAYS = [
  {
    label: "Monday",
    value: "0",
  },
  {
    label: "Tuesday",
    value: "1",
  },
  {
    label: "Wednesday",
    value: "2",
  },
  {
    label: "Thursday",
    value: "3",
  },
  {
    label: "Friday",
    value: "4",
  },
  {
    label: "Saturday",
    value: "5",
  },
  {
    label: "Sunday",
    value: "6",
  },
];

export const LIST_OPTION_BAR_DETAIL_REVIEW_STAR_RATING = [0, 1, 2, 3, 4, 5];

export const ENUM_BAR_DETAIL_REVIEW_STATUS = {
  ACTIVE: 1,
  DISABLE: 0,
};

export const COLOR_BAR_DETAIL_REVIEW_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "primary",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "warning",
};

export const COLOR_BAR_REVIEW_TYPE: any = {
  [0]: "#4CAF50",
  [1]: "#4A90E2",
};

export const LIST_OPTION_BAR_REVIEW_TYPE = [
  {
    value: 0,
    label: "User",
  },
  {
    value: 1,
    label: "System",
  },
];

export const COLOR_STICKER_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "success",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_REVIEW_STATUS = [
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE,
    label: "Active",
  },
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE,
    label: "Disable",
  },
];

export const ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS = {
  APPROVED: 1,
  WAITING: 0,
  REJECTED: 2,
};

export const COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS: any = {
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.APPROVED]: "success",
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.WAITING]: "warning",
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.REJECTED]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS = [
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.APPROVED,
    label: "Approved",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.WAITING,
    label: "Status Waiting",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.REJECTED,
    label: "Rejected",
  },
];

export const ENUM_TYPE_BARTENDER = {
  SYSTEM: 1,
  BARTENDER: 2,
};

export const COLOR_TYPE_BARTENDER: any = {
  [ENUM_TYPE_BARTENDER.SYSTEM]: "success",
  [ENUM_TYPE_BARTENDER.BARTENDER]: "primary",
};

export const LIST_OPTION_TYPE_BARTENDER = [
  {
    label: "System",
    value: ENUM_TYPE_BARTENDER.SYSTEM,
  },
  {
    label: "Bartender User",
    value: ENUM_TYPE_BARTENDER.BARTENDER,
  },
];

export const ENUM_STATUS_POST = {
  ACTIVATED: 1,
  DISABLED: 0,
};

export const COLOR_STATUS_POST: any = {
  [ENUM_STATUS_POST.ACTIVATED]: "success",
  [ENUM_STATUS_POST.DISABLED]: "danger",
};

export const STATUS_POST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_POST.ACTIVATED,
  },
  {
    label: "Status Disabled",
    value: ENUM_STATUS_POST.DISABLED,
  },
];

export const ENUM_STICKER_PACKAGE_TYPE = {
  STANDARD: 0,
  PREMIUM: 1,
};

export const COLOR_STICKER_PACKAGE_TYPE: any = {
  [ENUM_STICKER_PACKAGE_TYPE.STANDARD]: "success",
  [ENUM_STICKER_PACKAGE_TYPE.PREMIUM]: "danger",
};

export const STICKER_PACKAGE_TYPE_OPTION = [
  {
    label: "Package Type Standard",
    value: ENUM_STICKER_PACKAGE_TYPE.STANDARD,
  },
  {
    label: "Package Type Premium",
    value: ENUM_STICKER_PACKAGE_TYPE.PREMIUM,
  },
];

//reservation
export const ENUM_BOOKING_STATUS = {
  SERVING: 1,
  WAITING: 2,
  USING: 3,
  RELEASED: 4,
  DISABLED: 5,
  CANCELLED: 6,
};

export const ENUM_BOOKING_TYPE = {
  SELF_BOOKING: 1,
  STAFF_ASSISTED_BOOKING: 2,
};

export const ENUM_ARRANGE_STATUS = {
  ARRANGE: 1,
  NOT_ARRANGE: 2,
};

export const BOOKING_STATUS_OPTION = [
  {
    label: "Serving",
    value: ENUM_BOOKING_STATUS.SERVING,
  },
  {
    label: "Waiting",
    value: ENUM_BOOKING_STATUS.WAITING,
  },
  {
    label: "Using",
    value: ENUM_BOOKING_STATUS.USING,
  },
  {
    label: "Released",
    value: ENUM_BOOKING_STATUS.RELEASED,
  },
  {
    label: "Disabled",
    value: ENUM_BOOKING_STATUS.DISABLED,
  },
  {
    label: "Cancelled",
    value: ENUM_BOOKING_STATUS.CANCELLED,
  },
];

export const BOOKING_TYPE_OPTION = [
  { label: "self_booking", value: ENUM_BOOKING_TYPE.SELF_BOOKING },
  {
    label: "staff_assisted_booking",
    value: ENUM_BOOKING_TYPE.STAFF_ASSISTED_BOOKING,
  },
];

export const ARRANGE_STATUS_OPTION = [
  { label: "arrange", value: ENUM_ARRANGE_STATUS.ARRANGE },
  {
    label: "not_arrange",
    value: ENUM_ARRANGE_STATUS.NOT_ARRANGE,
  },
];

//bar detail - tables
export const ENUM_TABLE_SHARING = {
  ALLOW_SHARE: 1,
  NOT_ALLOW_SHARE: 0,
};

export const TABLE_SHARING_OPTION = [
  {
    label: "Allow Share",
    value: ENUM_TABLE_SHARING.ALLOW_SHARE,
  },
  {
    label: "Not Allow Share",
    value: ENUM_TABLE_SHARING.NOT_ALLOW_SHARE,
  },
];

export const ENUM_TABLE_TYPE = {
  VIP: 1,
  NORMAL: 2,
};

export const TABLE_TYPE_OPTION = [
  {
    label: "Vip",
    value: ENUM_TABLE_TYPE.VIP,
  },
  {
    label: "Normal",
    value: ENUM_TABLE_TYPE.NORMAL,
  },
];

//Agency
export const ENUM_AGENCY_STATUS = {
  ACTIVATED: "1",
  INACTIVATED: "2",
};

export const COLOR_AGENCY_STATUS: any = {
  [ENUM_AGENCY_STATUS.ACTIVATED]: "success",
  [ENUM_AGENCY_STATUS.INACTIVATED]: "danger",
};

export const AGENCY_STATUS_OPTION = [
  { label: "Active", value: ENUM_AGENCY_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_AGENCY_STATUS.INACTIVATED },
];

export const ENUM_AGENCY = {
  NOT_BELONG_TO_AGENCY: "0",
};

export const ENUM_CAMPAIGN = {
  NOT_BELONG_TO_CAMPAIGN: "0",
};

export const COLOR_AGENCY_OPTION: any = {
  [ENUM_AGENCY.NOT_BELONG_TO_AGENCY]: "danger",
};

export const LIST_AGENCY_OPTION = [
  { label: "Not belong to Agency", value: ENUM_AGENCY.NOT_BELONG_TO_AGENCY },
];

export const LIST_CAMPAIGN_OPTION = [
  {
    label: "Not belong to Campaign",
    value: ENUM_CAMPAIGN.NOT_BELONG_TO_CAMPAIGN,
  },
];

//Campaign
export const ENUM_STATUS_CAMPAIGN = {
  NOT_YET: "not_yet",
  ON_GOING: "on_going",
  END: "end",
};

export const COLOR_STATUS_CAMPAIGN: any = {
  [ENUM_STATUS_CAMPAIGN.NOT_YET]: "warning",
  [ENUM_STATUS_CAMPAIGN.ON_GOING]: "primary",
  [ENUM_STATUS_CAMPAIGN.END]: "danger",
};

export const LIST_STATUS_CAMPAIGN_OPTION = [
  {
    label: "Not yet",
    value: ENUM_STATUS_CAMPAIGN.NOT_YET,
  },
  {
    label: "On-Going",
    value: ENUM_STATUS_CAMPAIGN.ON_GOING,
  },
  {
    label: "End",
    value: ENUM_STATUS_CAMPAIGN.END,
  },
];

export const LIST_CHANNEL_OPTION = [
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "Offline",
    value: "offline",
  },
];

export const ENUM_AGENCY_BRANCH_STATUS = {
  LINKED: 1,
  NOT_LINK_YET: 2,
};

export const COLOR_AGENCY_BRANCH_STATUS: any = {
  [ENUM_AGENCY_BRANCH_STATUS.LINKED]: "success",
  [ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET]: "danger",
};

export const AGENCY_BRANCH_STATUS_OPTION = [
  {
    label: "Linked",
    value: ENUM_AGENCY_BRANCH_STATUS.LINKED,
  },
  {
    label: "Not Link Yet",
    value: ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET,
  },
];

export const AGENCY_APP_NAME_OPTION = [
  {
    label: "User",
    value: "baive",
  },
  {
    label: "Management",
    value: "baive_manager",
  },
];

export const ENUM_AGENCY_EVENT_ACTION_TYPE = {
  INSTALL: "install",
  OPEN: "open",
};

export const COLOR_AGENCY_EVENT_ACTION_TYPE: any = {
  [ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL]: "primary",
  [ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN]: "success",
};

export const AGENCY_EVENT_ACTION_TYPE_OPTION = [
  {
    label: "Install",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL,
  },
  {
    label: "Open",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN,
  },
];

export const PERIOD_DATE_OPTION = [
  {
    label: "No Specific Dates",
    value: "2",
  },
  {
    label: "Custom Period",
    value: "1",
  },
];

export const MANUAL_PUSH_REDIRECT_SCREEN_TARGET = [
  {
    label: "Open App",
    value: "default",
  },

  {
    label: "Open Deep Link",
    value: "open-link",
  },
  {
    label: "Log Bar",
    value: "bar",
  },
  {
    label: "Log Bar Management",
    value: "bar-management",
  },
  {
    label: "Log Wink",
    value: "wink",
  },
  {
    label: "Log News",
    value: "news",
  },
  {
    label: "Log Chat",
    value: "chat",
  },
  {
    label: "Profile",
    value: "profile",
  },
];

export const ENUM_MANUAL_PUSH_SEND_TIME = {
  IMMEDIATELY: "immediately",
  SCHEDULE: "schedule",
};

export const COLOR_MANUAL_PUSH_SEND_TIME: any = {
  [ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY]: "primary",
  [ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE]: "warning",
};

export const MANUAL_PUSH_SEND_TIME_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY,
    label: "Immediately",
  },
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE,
    label: "Schedule",
  },
];

export const ENUM_PUSH_LOG_OPEN_STATUS = {
  OPEN: 1,
  NOTOPEN: 0,
};

export const COLOR_OPEN_STATUS: any = {
  [ENUM_PUSH_LOG_OPEN_STATUS.OPEN]: "primary",
  [ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN]: "danger",
};

export const PUSH_LOG_OPEN_STATUS = [
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.OPEN,
    label: "Log Open",
  },
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN,
    label: "Log Not-Open",
  },
];

export const PUSH_LOG_NOTIFY_TYPE = [
  {
    value: ENUM_NOTIFY_TYPE.AUTO,
    label: "Auto",
  },
  {
    value: ENUM_NOTIFY_TYPE.MANUAL,
    label: "Manual",
  },
];

export const ENUM_PUSH_LOG_PUSH_STATUS = {
  SENT: "sent",
  FAILED: "failed",
  DEACTIVATED: "deactivated",
};

export const ENUM_REFERRAL_LOG_STATUS = {
  FAILED: "0",
  SUCCESS: "1",
};

export const REFERRAL_LOG_STATUS = [
  {
    value: ENUM_REFERRAL_LOG_STATUS.FAILED,
    label: "Failed",
  },
  {
    value: ENUM_REFERRAL_LOG_STATUS.SUCCESS,
    label: "Success",
  },
];

export const COLOR_REFERRAL_LOG_STATUS = {
  [ENUM_REFERRAL_LOG_STATUS.FAILED]: "danger",
  [ENUM_REFERRAL_LOG_STATUS.SUCCESS]: "success",
};

export const COLOR_PUSH_LOG_STATUS = {
  [ENUM_PUSH_LOG_PUSH_STATUS.SENT]: "success",
  [ENUM_PUSH_LOG_PUSH_STATUS.FAILED]: "danger",
  [ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED]: "warning",
};

export const PUSH_LOG_PUSH_STATUS = [
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.SENT,
    label: "Sent",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.FAILED,
    label: "Failed",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED,
    label: "Sending",
  },
];

export const ENUM_MANUAL_PUSH_STATUS = {
  COMPLETED: "completed",
  INPROGRESS: "processing",
  WAITING: "waiting",
  CANCEL: "cancel",
};

export const COLOR_MANUAL_PUSH_STATUS = {
  [ENUM_MANUAL_PUSH_STATUS.COMPLETED]: "success",
  [ENUM_MANUAL_PUSH_STATUS.INPROGRESS]: "blue",
  [ENUM_MANUAL_PUSH_STATUS.WAITING]: "warning",
  [ENUM_MANUAL_PUSH_STATUS.CANCEL]: "danger",
};

export const MANUAL_PUSH_STATUS = [
  {
    value: ENUM_MANUAL_PUSH_STATUS.COMPLETED,
    label: "Complete",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.INPROGRESS,
    label: "Processing",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.WAITING,
    label: "Manual Push Waiting",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.CANCEL,
    label: "Cancel",
  },
];

//Coupon issue
export const ENUM_COUPON_USE_STATUS = {
  USED: "1",
  NOT_USED: "2",
  EXPIRED: "3",
};

export const COLOR_COUPON_USE_STATUS: any = {
  [ENUM_COUPON_USE_STATUS.USED]: "success",
  [ENUM_COUPON_USE_STATUS.NOT_USED]: "warning",
  [ENUM_COUPON_USE_STATUS.EXPIRED]: "danger",
};

export const COUPON_USE_STATUS_OPTION = [
  { label: "Used", value: ENUM_COUPON_USE_STATUS.USED },
  { label: "Not-Used", value: ENUM_COUPON_USE_STATUS.NOT_USED },
  { label: "Expired", value: ENUM_COUPON_USE_STATUS.EXPIRED },
];

// Coupon Action Log

//Coupon
export const ENUM_COUPON_LOG_STATUS = {
  SUCCESS: 1,
  ERROR: 2,
};

export const COLOR_COUPON_LOG_STATUS: any = {
  [ENUM_COUPON_LOG_STATUS.SUCCESS]: "success",
  [ENUM_COUPON_LOG_STATUS.ERROR]: "danger",
};

export const COUPON_ACTION_LOG_STATUS = [
  { label: "Success", value: ENUM_COUPON_LOG_STATUS.SUCCESS },
  { label: "Error", value: ENUM_COUPON_LOG_STATUS.ERROR },
];

// User is guest
export const ENUM_USER_REAL_GUEST = {
  GUEST: "1",
  USER: "0",
};

export const ENUM_GUEST_MODE = {
  GUEST: "1",
  USER: "0",
};

export const COLOR_USER_REAL_GUEST: any = {
  [ENUM_USER_REAL_GUEST.GUEST]: "orange",
  [ENUM_USER_REAL_GUEST.USER]: "success",
};

export const USER_REAL_GUEST_OPTION = [
  { label: "Normal User", value: ENUM_USER_REAL_GUEST.USER },
  { label: "Guest", value: ENUM_USER_REAL_GUEST.GUEST },
];

export const GUEST_MODE_OPTION = [
  { label: "Normal", value: ENUM_GUEST_MODE.USER },
  { label: "Guest", value: ENUM_GUEST_MODE.GUEST },
];

export const LIST_USER_LOG_TYPE_OPTION = [
  { label: "Periodically Updated", value: 1 },
  /* { label: "Sign Up", value: 2 }, */
  { label: "Sign In", value: 3 },
  { label: "Bar List", value: 4 },
  { label: "Wink List", value: 5 },
];

export const COLOR_USER_LOG_TYPE: any = {
  [1]: "orange",
  [2]: "success",
  [3]: "danger",
  [4]: "primary",
  [5]: "purple",
};

export const LIST_OPTION_SOURCE_APP = [
  {
    label: "App User",
    value: "baive",
  },
  {
    label: "App Management",
    value: "baive_manager",
  },
];

export const LIST_OPTION_MENU = [
  {
    label: "Bar",
    value: "1",
  },
  {
    label: "Bar Manager",
    value: "2",
  },
  {
    label: "Feed",
    value: "3",
  },
  {
    label: "Wink",
    value: "4",
  },
  {
    label: "News",
    value: "5",
  },
  {
    label: "Profile",
    value: "6",
  },
];

export const APP_TYPE_OPTIONS: Option[] = [
  {
    label: "Type User",
    value: "user",
  },
  {
    label: "Type Management",
    value: "manager",
  },
];

// User Type on Log page
export const ENUM_USER_TYPE_LOG = {
  GUEST: "1",
  NORMAL_USER: "2",
  BARTENDER: "3",
  MANAGER: "4",
};

export const ENUM_USER_TYPE_REFERRAL_LOG = {
  NORMAL_USER: "1",
  BARTENDER: "2",
  MANAGER: "3",
};

export const COLOR_USER_TYPE_REFERRAL_LOG: any = {
  [ENUM_USER_TYPE_REFERRAL_LOG.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_REFERRAL_LOG.BARTENDER]: "danger",
  [ENUM_USER_TYPE_REFERRAL_LOG.MANAGER]: "info",
};

export const USER_TYPE_REFERRAL_LOG_OPTION = [
  { label: "Normal User", value: ENUM_USER_TYPE_REFERRAL_LOG.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_REFERRAL_LOG.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_REFERRAL_LOG.MANAGER },
];

export const COLOR_USER_TYPE_LOG: any = {
  [ENUM_USER_TYPE_LOG.GUEST]: "warning",
  [ENUM_USER_TYPE_LOG.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_LOG.BARTENDER]: "danger",
  [ENUM_USER_TYPE_LOG.MANAGER]: "info",
};

export const USER_TYPE_LOG_OPTION = [
  { label: "Guest", value: ENUM_USER_TYPE_LOG.GUEST },
  { label: "Normal User", value: ENUM_USER_TYPE_LOG.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_LOG.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_LOG.MANAGER },
];

export const LIST_CHANNEL_USER_OPTION = [
  {
    label: "Store Channel",
    value: "store",
  },
  {
    label: "Agency",
    value: "agency",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Meta",
    value: "meta",
  },
];

// event log

export const BAR_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Bar Screen Access Screen",
  },
  {
    value: "view_detail_bar",
    label: "Bar Screen View Bar Detail",
  },
  {
    value: "search_bar",
    label: "Bar Screen Search Bar",
  },
  {
    value: "view_map_bar",
    label: "Bar Screen View Bar Map",
  },
  {
    value: "my_location_bar",
    label: "Bar Screen Bar Location",
  },
  {
    value: "filter_bar",
    label: "Bar Screen Filter Bar",
  },
  {
    value: "reload_bar",
    label: "Bar Screen Reload Bar",
  },
  {
    value: "view_review_bar",
    label: "Bar Screen View Bar Review",
  },
];

export const BAR_DETAIL_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Bar Detail Screen Access Screen",
  },
  {
    value: "view_background_photo_bar",
    label: "Bar Detail Screen View Bar Background Photo",
  },
  {
    value: "view_photo_bar",
    label: "Bar Detail Screen View Bar Photo",
  },
  {
    value: "call_bar",
    label: "Bar Detail Screen Call Bar",
  },
  {
    value: "connect_other_user",
    label: "Bar Detail Screen Connect Other User",
  },
  {
    value: "contact_us_bar",
    label: "Bar Detail Screen Bar Contact",
  },
  {
    value: "share_bar",
    label: "Bar Detail Screen Share Bar",
  },
  {
    value: "get_direction_bar",
    label: "Bar Detail Screen Get Bar Direction",
  },
  {
    value: "view_profile_bartender_bar",
    label: "Bar Detail Screen View Bartender Profile",
  },
  {
    value: "view_menu_photo_bar",
    label: "Bar Detail Screen View Bar Menu Photo",
  },
  {
    value: "view_review_bar",
    label: "Bar Detail Screen View Bar Review",
  },
];

export const BAR_MANAGEMENT_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Bar Management Screen Access Screen",
  },
  {
    value: "edit_bar",
    label: "Bar Management Screen Edit Bar",
  },
  {
    value: "coupon_management",
    label: "Bar Management Screen Coupon Management",
  },
  {
    value: "ads_management",
    label: "Bar Management Screen Ads Management",
  },
  {
    value: "connect_other_user",
    label: "Bar Management Screen Connect Other User",
  },
  {
    value: "welcome_message",
    label: "Bar Management Screen Welcome Message",
  },
  {
    value: "review_management",
    label: "Bar Management Screen Review Management",
  },
  {
    value: "view_menu_photo_bar",
    label: "Bar Management Screen View Bar Menu Photo",
  },
  {
    value: "view_profile_bartender_bar",
    label: "Bar Management Screen View Bartender Profile",
  }
];

export const BAR_REVIEW_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Bar Review Screen Access Screen",
  },
  {
    value: "write_review_bar",
    label: "Bar Review Screen Write Review",
  },
  {
    value: "edit_review_bar",
    label: "Bar Review Screen Edit Review",
  },
  {
    value: "delete_review_bar",
    label: "Bar Review Screen Delete Review",
  },
];

export const WINK_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Access Screen",
  },
  {
    value: "like_wink",
    label: "Wink Screen Like Wink",
  },
  {
    value: "share_wink",
    label: "Wink Screen Share Wink",
  },
  {
    value: "view_comment_wink",
    label: "Wink Screen View Wink Comment",
  },
  {
    value: "search_wink",
    label: "Wink Screen Search Wink",
  },
  {
    value: "view_photo_wink",
    label: "Wink Screen View Wink Photo",
  },
  {
    value: "connect_user_wink",
    label: "Wink Screen Connect Wink User",
  },
  {
    value: "start_chat",
    label: "Wink Screen Start Chat",
  },
];

export const WINK_DETAIL_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Wink Detail Screen Access Screen",
  },
  { value: "like_wink", label: "Wink Detail Screen Like Wink" },
  { value: "share_wink", label: "Wink Detail Screen Share Wink" },
  { value: "view_comment_wink", label: "Wink Detail Screen View Wink Comment" },
  { value: "view_photo_wink", label: "Wink Detail Screen View Wink Photo" },
  { value: "connect_user_wink", label: "Wink Detail Screen Connect Wink User" },
  {
    value: "block_comment_wink",
    label: "Wink Detail Screen Block Wink Comment",
  },
  {
    value: "delete_comment_wink",
    label: "Wink Detail Screen Delete Wink Comment",
  },
  { value: "edit_comment_wink", label: "Wink Detail Screen Edit Wink Comment" },
  { value: "report_comment_wink", label: "Wink Detail Screen Report Comment" },
  {
    value: "write_comment_wink",
    label: "Wink Detail Screen Write Wink Comment",
  },
  {
    value: "view_author_of_comment",
    label: "Wink Detail Screen View Author Of Comment",
  }
];

export const WINK_COMMENT_SCREEN_CONST = [
  { value: "report_comment_wink", label: "Report Comment" },
  { value: "block_comment_wink", label: "Block Comment" },
  { value: "write_comment_wink", label: "Write Comment" },
  { value: "edit_comment_wink", label: "Edit Comment" },
  { value: "delete_comment_wink", label: "Delete Comment" },
  { value: "view_author_of_comment", label: "View Author Of Comment" },
  {
    value: "access_screen",
    label: "Access Screen",
  },
];

export const NEWS_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "News Screen Access Screen",
  },
  { value: "view_news_detail", label: "News Screen View Detail" },
  { value: "search_news", label: "News Screen Search News" },
];

export const MY_PROFILE_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "My Profile Screen Access Screen",
  },
  { value: "coupon_my_profile", label: "My Profile Screen Coupon" },
  { value: "qrcode_my_profile", label: "My Profile Screen QR" },
  { value: "view_post_my_profile", label: "My Profile Screen View My Post" },
  { value: "edit_my_profile", label: "My Profile Screen Edit Profile" },
  { value: "like_wink", label: "My Profile Screen Like Wink" },
  { value: "view_comment_wink", label: "My Profile Screen View Wink Comment" },
  { value: "view_photo_wink", label: "My Profile Screen View Wink Photo" },
];

export const LIST_POST_MY_PROFILE_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "List Post My Profile Screen Access Screen",
  },
  { value: "share_wink", label: "List Post My Profile Screen Share Wink" },
  {
    value: "view_comment_wink",
    label: "List Post My Profile Screen View Wink Comment",
  },
  { value: "like_wink", label: "List Post My Profile Screen Like Wink" },
];

export const OTHER_PROFILE_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Other Profile Access Screen",
  },
  {
    value: "connect_other_user",
    label: "Other Profile Screen Connect Other User",
  },
  {
    value: "connect_user_wink",
    label: "Other Profile Screen Connect Wink User",
  },
  { value: "chat_other_user", label: "Other Profile Screen Chat Other User" },
  { value: "share_other_user", label: "Other Profile Screen Share Other User" },
  { value: "block_other_user", label: "Other Profile Screen Block Other User" },
  {
    value: "view_comment_wink",
    label: "Other Profile Screen View Wink Comment",
  },
  { value: "view_photo_wink", label: "Other Profile Screen View Wink Photo" },
  { value: "like_wink", label: "Other Profile Screen Like Wink" },
  { value: "share_wink", label: "Other Profile Screen Share Wink" },
];

export const CHAT_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Chat Screen Access Screen",
  },
  { value: "create_group", label: "Chat Screen Create Group" },
  { value: "get_connected_user", label: "Chat Screen Connected User" },
  { value: "get_conversation", label: "Chat Screen Conversation" },
  {
    value: "newest_user|open_user_profile",
    label: "Chat Screen Newest User -> Open Profile",
  },
  {
    value: "newest_user|connect_other_user",
    label: "Chat Screen Newest User -> Connect Other User",
  },
  {
    value: "newest_user|start_chat",
    label: "Chat Screen Newst User -> Start Chat",
  },
  {
    value: "conversation|start_chat",
    label: "Chat Screen Conversation -> Start Chat",
  },
  {
    value: "connected_user|start_chat",
    label: "Chat Screen Connected User -> Start Chat",
  },
  { value: "search_chat", label: "Chat Screen Search Chat" },
];

export const NOTIFICATION_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Notification Screen Access Screen",
  },
  {
    value: "open_notification",
    label: "Notification Screen Open Notification",
  },
  {
    value: "open_user_profile",
    label: "Notification Screen Open User Profile",
  },
  {
    value: "connect_other_user",
    label: "Notification Screen Connect Other User",
  },
];

export const SETTING_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Setting Screen Access Screen",
  },
  { value: "account_setting", label: "Setting Screen Account Setting" },
  { value: "change_language", label: "Setting Screen Change Language" },
  { value: "notification", label: "Setting Screen Notification" },
  { value: "blocked_list", label: "Setting Screen Blocked List" },
  { value: "contact_feedback", label: "Setting Screen Contact Feedback" },
  { value: "faq", label: "Setting Screen FAQ" },
  { value: "notice", label: "Setting Screen Notice" },
  { value: "logout", label: "Setting Screen Logout" },
];

export const LOGIN_SCREEN_CONST = [
  {
    value: "access_screen",
    label: "Login Screen Access Screen",
  }
];

export const SCAN_QR_SCREEN = [
  {
    value: "access_screen",
    label: "Scan QR Screen Access Screen",
  },
  { value: "shared_link", label: "Scan QR Screen Shared Link" },
  { value: "shared", label: "Scan QR Screen Shared" },
  { value: "scan", label: "Scan QR Screen Scan" },
  { value: "download", label: "Scan QR Screen Download" },
];

export const SCREEN_CONST = [
  {
    value: "bar_screen",
    label: "Bar Screen",
    children: BAR_SCREEN_CONST,
  },
  {
    value: "bar_review_screen",
    label: "Bar Review Screen",
    children: BAR_REVIEW_SCREEN_CONST,
  },
  {
    value: "bar_detail_screen",
    label: "Bar Detail Screen",
    children: BAR_DETAIL_SCREEN_CONST,
  },
  {
    value: "bar_management_screen",
    label: "Bar Management Screen",
    children: BAR_MANAGEMENT_SCREEN_CONST,
  },
  {
    value: "wink_screen",
    label: "Wink Screen",
    children: WINK_SCREEN_CONST,
  },
  {
    value: "wink_comment_screen",
    label: "Wink Comment",
    children: WINK_COMMENT_SCREEN_CONST,
  },
  {
    value: "wink_detail_screen",
    label: "Wink Detail Screen",
    children: WINK_DETAIL_SCREEN_CONST,
  },
  {
    value: "news_screen",
    label: "News Screen",
    children: NEWS_SCREEN_CONST,
  },
  {
    value: "chat_main_screen",
    label: "Chat Screen",
    children: CHAT_SCREEN_CONST,
  },
  {
    value: "my_account_screen",
    label: "My Profile Screen",
    children: MY_PROFILE_SCREEN_CONST,
  },
  {
    value: "list_post_my_profile",
    label: "List Post My Profile Screen",
    children: LIST_POST_MY_PROFILE_SCREEN_CONST,
  },
  {
    value: "other_user_profile",
    label: "Other's Profile Screen",
    children: OTHER_PROFILE_SCREEN_CONST,
  },
  {
    value: "coupon_screen",
    label: "Coupon Screen",
    children: [],
  },
  {
    value: "scan_qrcode_screen",
    label: "Scan QR Screen",
    children: SCAN_QR_SCREEN,
  },
  {
    value: "notification_screen",
    label: "Notification Screen",
    children: NOTIFICATION_SCREEN_CONST,
  },
  {
    value: "setting_screen",
    label: "Setting Screen",
    children: SETTING_SCREEN_CONST,
  },
  {
    value: "login_screen",
    label: "Login",
    children: LOGIN_SCREEN_CONST,
  },
  // {
  //   value: "access_screen",
  //   label: "Access Screen",
  // },
];

//end of event log

//start of notification
export const NOTIFICATION_ACTION = [
  { value: "default", label: "Open App" },
  { value: "connect", label: "Connect" },
  { value: "comment", label: "Comment" },
  { value: "message", label: "Message" },
  { value: "home", label: "Home" },
  { value: "search", label: "Search" },
  { value: "explore", label: "Explore" },
  { value: "like", label: "Like" },
  { value: "dislike", label: "Dislike" },
  { value: "bookmark", label: "Bookmark" },
  { value: "unbookmark", label: "Unbookmark" },
  { value: "message-private-chat", label: "Message Private Chat" },
  { value: "message-group-chat", label: "Message Group Chat" },
  { value: "open-link", label: "Open Link" },
  { value: "bar", label: "Notify Bar" },
  { value: "bar-management", label: "Notify Bar Management" },
  { value: "wink", label: "Wink" },
  { value: "news", label: "News" },
  { value: "chat", label: "Chat" },
  { value: "profile", label: "Profile" },
  { value: "share", label: "Shared" },
];

export const ENUM_USER_TYPE_BAR = {
  NORMAL_USER: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_USER_TYPE_BAR: any = {
  [ENUM_USER_TYPE_BAR.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_BAR.BARTENDER]: "danger",
  [ENUM_USER_TYPE_BAR.MANAGER]: "info",
};

export const USER_TYPE_BAR_OPTION = [
  { label: "Normal User", value: ENUM_USER_TYPE_BAR.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_BAR.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_BAR.MANAGER },
];

//hashtag
export const ENUM_HASHTAG_STATUS = {
  ACTIVATED: 1,
  INACTIVATED: 0,
};

export const COLOR_HASHTAG_STATUS: any = {
  [ENUM_HASHTAG_STATUS.ACTIVATED]: "success",
  [ENUM_HASHTAG_STATUS.INACTIVATED]: "danger",
};

export const HASHTAG_STATUS_OPTION = [
  { label: "Active", value: ENUM_HASHTAG_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_HASHTAG_STATUS.INACTIVATED },
];

//Wink
export const ENUM_WINK_TYPE_USER = {
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_WINK_TYPE_USER: any = {
  [ENUM_WINK_TYPE_USER.BARTENDER]: "danger",
  [ENUM_WINK_TYPE_USER.MANAGER]: "info",
};

export const WINK_TYPE_USER_OPTION = [
  { label: "Bartender", value: ENUM_WINK_TYPE_USER.BARTENDER },
  { label: "Wink Manager", value: ENUM_WINK_TYPE_USER.MANAGER },
];

export const AGENCY_CUSTOM_PARAM_CHANNEL_OPTION = [
  {
    label: "Google Ads Tracking",
    value: "google",
  },
  {
    label: "Meta Ads tracking",
    value: "meta",
  },
];

// Chat type on chat log page
export const ENUM_CHAT_TYPE_LOG = {
  PRIVATE: "private",
  GROUP: "group",
};

export const COLOR_CHAT_TYPE_LOG: any = {
  [ENUM_CHAT_TYPE_LOG.PRIVATE]: "orange",
  [ENUM_CHAT_TYPE_LOG.GROUP]: "success",
};

export const CHAT_TYPE_LOG_OPTION = [
  { label: "Private", value: ENUM_CHAT_TYPE_LOG.PRIVATE },
  { label: "Group", value: ENUM_CHAT_TYPE_LOG.GROUP },
];

// User Type on Log page
export const ENUM_USER_TYPE_CHAT_LOG = {
  GUEST: -1,
  NORMAL_USER: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_USER_TYPE_CHAT_LOG: any = {
  [ENUM_USER_TYPE_CHAT_LOG.GUEST]: "warning",
  [ENUM_USER_TYPE_CHAT_LOG.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_CHAT_LOG.BARTENDER]: "danger",
  [ENUM_USER_TYPE_CHAT_LOG.MANAGER]: "info",
};

export const USER_TYPE_CHAT_LOG_OPTION = [
  { label: "Guest", value: ENUM_USER_TYPE_CHAT_LOG.GUEST },
  { label: "Normal User", value: ENUM_USER_TYPE_CHAT_LOG.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_CHAT_LOG.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_CHAT_LOG.MANAGER },
];

export const ENUM_CONTENT_TYPE_CHAT_LOG = {
  MESSAGE: "message",
  ATTACHMENT: "file",
  STICKER: "sticker",
};

export const COLOR_CONTENT_TYPE_CHAT_LOG: any = {
  [ENUM_CONTENT_TYPE_CHAT_LOG.MESSAGE]: "warning",
  [ENUM_CONTENT_TYPE_CHAT_LOG.ATTACHMENT]: "primary",
  [ENUM_CONTENT_TYPE_CHAT_LOG.STICKER]: "success",
};

export const CONTENT_TYPE_CHAT_LOG_OPTION = [
  { label: "Message", value: ENUM_CONTENT_TYPE_CHAT_LOG.MESSAGE },
  { label: "Attachment", value: ENUM_CONTENT_TYPE_CHAT_LOG.ATTACHMENT },
  { label: "Sticker", value: ENUM_CONTENT_TYPE_CHAT_LOG.STICKER },
];

//Send push
export const ENUM_MANUAL_PUSH_SAVE_OPTION = {
  SAVE: 1,
  NOT_SAVE: 0,
};

export const COLOR_MANUAL_PUSH_SAVE_OPTION: any = {
  [ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE]: "primary",
  [ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE]: "warning",
};

export const MANUAL_PUSH_SAVE_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE,
    label: "Save",
  },
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE,
    label: "Not-save",
  },
];

export const USER_FCM_TOKEN_OPTION = [
  {
    label: "With Token",
    value: "1",
  },
  {
    label: "Without Token",
    value: "0",
  },
];

export const USER_STATUS_SIGNUP_OPTION = [
  {
    label: "Sign-up Stopped",
    value: "stopped",
  },
  {
    label: "Sign-up Complete",
    value: "completed",
  },
];

export const USER_STORE_CONNECTION_OPTION = [
  {
    label: "Store Not Linked",
    value: "not_linked",
  },
  {
    label: "Store Linked",
    value: "linked",
  },
];

// inquiry
export const INQUIRY_TYPE = [
  {
    label: "Report Bug",
    value: 1,
  },
  {
    label: "Account Issue",
    value: 2,
  },
  {
    label: "Service Inquiry",
    value: 3,
  },
  {
    label: "Payment Refund",
    value: 4,
  },
  {
    label: "Complaint",
    value: 5,
  },
];

export const COLOR_INQUIRY_TYPE: any = {
  [1]: "danger",
  [2]: "secondary",
  [3]: "success",
  [4]: "primary",
  [5]: "warning",
};

export const INQUIRY_STATUS = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In-Progress",
    value: 2,
  },
  {
    label: "Resolved",
    value: 3,
  },
  {
    label: "Closed",
    value: 4,
  },
];

export const COLOR_INQUIRY_STATUS: any = {
  [1]: "warning",
  [2]: "primary",
  [3]: "success",
  [4]: "danger",
};

export const HEXCOLOR_INQUIRY_STATUS: any = {
  [1]: "#ffc107",
  [2]: "#007bff",
  [3]: "#28a745",
  [4]: "#dc3545",
};

export const INQUIRY_REPLY_TYPE = [
  {
    label: "User",
    value: 1,
  },
  {
    label: "Admin",
    value: 2,
  },
];

export const INQUIRY_ATTACHMENT_TYPE = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In-Progress",
    value: 2,
  },
  {
    label: "Resolved",
    value: 3,
  },
];

export const USER_NOTIFICATION_ALLOW_TYPE_OPTION = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Connect",
    value: "connect",
  },
  {
    label: "Comment",
    value: "comment",
  },
  {
    label: "Message",
    value: "message",
  },
  {
    label: "Like",
    value: "like",
  },
  {
    label: "Share",
    value: "share",
  },
  {
    label: "Promotion Event",
    value: "promotion_event",
  },
  {
    label: "Inquiry",
    value: "inquiry",
  },
];

//Referral
export const ENUM_REFERRAL_RULE_ROLE = {
  BARTENDER: "bartender",
  USER: "user",
  MANAGER: "manager",
};

export const COLOR_REFERRAL_RULE_ROLE: any = {
  [ENUM_REFERRAL_RULE_ROLE.BARTENDER]: "danger",
  [ENUM_REFERRAL_RULE_ROLE.USER]: "success",
  [ENUM_REFERRAL_RULE_ROLE.MANAGER]: "info",
};

export const LIST_REFERRAL_RULE_ROLE_OPTION = [
  {
    label: "Label Manager",
    value: ENUM_REFERRAL_RULE_ROLE.MANAGER,
  },
  {
    value: ENUM_REFERRAL_RULE_ROLE.BARTENDER,
    label: "Bartender",
  },
  {
    value: ENUM_REFERRAL_RULE_ROLE.USER,
    label: "User",
  },
];

export const LIST_CURRENCY_OPTION = [
  {
    label: "KRW",
    value: "KRW",
  },
  {
    label: "USD",
    value: "USD",
  },
];

export const ENUM_REFERRAL_REWARD_STATUS = {
  CODE_ENTERED: "code_entered",
  PENDING: "pending",
  REJECTED: "rejected",
  CONFIRMED: "confirmed",
  PAID: "paid",
};

export const COLOR_REFERRAL_REWARD_STATUS: any = {
  [ENUM_REFERRAL_REWARD_STATUS.CODE_ENTERED]: "code_entered",
  [ENUM_REFERRAL_REWARD_STATUS.PENDING]: "pending",
  [ENUM_REFERRAL_REWARD_STATUS.REJECTED]: "rejected",
  [ENUM_REFERRAL_REWARD_STATUS.CONFIRMED]: "confirmed",
  [ENUM_REFERRAL_REWARD_STATUS.PAID]: "paid",
};

export const LIST_REFERRAL_REWARD_STATUS_OPTION = [
  {
    value: ENUM_REFERRAL_REWARD_STATUS.CODE_ENTERED,
    label: "Code entered",
  },
  {
    value: ENUM_REFERRAL_REWARD_STATUS.PENDING,
    label: "Waiting for Review",
  },
  {
    value: ENUM_REFERRAL_REWARD_STATUS.REJECTED,
    label: "Rejected",
  },
  {
    value: ENUM_REFERRAL_REWARD_STATUS.CONFIRMED,
    label: "Confirmed",
  },
  {
    value: ENUM_REFERRAL_REWARD_STATUS.PAID,
    label: "Paid",
  },
];

// VOC Management
export const ENUM_VOC_TYPE = {
  USING_APP: 1,
  WITHDRAW_ACCOUNT: 2,
};

export const COLOR_VOC_TYPE: any = {
  [ENUM_VOC_TYPE.USING_APP]: "primary",
  [ENUM_VOC_TYPE.WITHDRAW_ACCOUNT]: "warning",
};

export const LIST_VOC_TYPE_OPTION = [
  {
    value: ENUM_VOC_TYPE.USING_APP,
    label: "Using App",
  },
  {
    value: ENUM_VOC_TYPE.WITHDRAW_ACCOUNT,
    label: "Withdraw account",
  },
];

export const ENUM_IS_REQUIRED_CONTENT = {
  REQUIRED: 1,
  NO_REQUIRED: 0,
};

export const COLOR_IS_REQUIRED_CONTENT: any = {
  [ENUM_IS_REQUIRED_CONTENT.REQUIRED]: "danger",
  [ENUM_IS_REQUIRED_CONTENT.NO_REQUIRED]: "success",
};

export const LIST_IS_REQUIRED_CONTENT_OPTION = [
  {
    value: ENUM_IS_REQUIRED_CONTENT.REQUIRED,
    label: "Required",
  },
  {
    value: ENUM_IS_REQUIRED_CONTENT.NO_REQUIRED,
    label: "Not required",
  },
];

export const ENUM_WITHDRAW_STATUS = {
  REQUESTED: "requested",
  PROCESSING: "processing",
  COMPLETE: "completed",
  REJECTED: "rejected",
  NEEDS_CORRECTION: "needs_correction",
  CANCELLED_BY_USER: "cancelled",
};

export const COLOR_WITHDRAW_STATUS: any = {
  [ENUM_WITHDRAW_STATUS.REQUESTED]: "warning",
  [ENUM_WITHDRAW_STATUS.PROCESSING]: "primary",
  [ENUM_WITHDRAW_STATUS.COMPLETE]: "success",
  [ENUM_WITHDRAW_STATUS.REJECTED]: "danger",
  [ENUM_WITHDRAW_STATUS.NEEDS_CORRECTION]: "orange",
  [ENUM_WITHDRAW_STATUS.CANCELLED_BY_USER]: "secondary",
};

export const LIST_WITHDRAW_STATUS_OPTION = [
  {
    value: ENUM_WITHDRAW_STATUS.REQUESTED,
    label: "Requested",
  },
  {
    value: ENUM_WITHDRAW_STATUS.PROCESSING,
    label: "Processing",
  },
  {
    value: ENUM_WITHDRAW_STATUS.COMPLETE,
    label: "Completed",
  },
  {
    value: ENUM_WITHDRAW_STATUS.REJECTED,
    label: "Rejected",
  },
  {
    value: ENUM_WITHDRAW_STATUS.NEEDS_CORRECTION,
    label: "Needs Correction",
  },
  {
    value: ENUM_WITHDRAW_STATUS.CANCELLED_BY_USER,
    label: "User Cancelled",
  },
];
